import React from 'react';
import { useTranslation } from 'react-i18next';

const STAT_KEYS = [
  'filters',
  'universe',
  'refresh',
  'languages',
  'ai',
  'channels',
] as const;

const StatsGrid: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section
      id="trust"
      className="py-4 py-md-5"
      style={{ backgroundColor: 'var(--surface_container_low)' }}
      aria-labelledby="trust-headline"
    >
      <div className="container">
        <div className="text-center mb-4">
          <h2
            id="trust-headline"
            className="landing-section__h2 fw-semibold mb-0"
            style={{
              fontFamily: 'var(--font-display)',
              color: 'var(--text-primary)',
            }}
          >
            {t('landing.stats.headline')}
          </h2>
        </div>

        <div className="row g-3" role="list">
          {STAT_KEYS.map((statKey, index) => (
            <div
              key={statKey}
              role="listitem"
              className="col-6 col-md-4"
              style={{
                animation: `fadeInUp 0.6s ease-out ${index * 80}ms forwards`,
                opacity: '0',
              }}
            >
              <div
                className="h-100 p-3 rounded-3"
                data-testid={`stat-${statKey}`}
                style={{
                  backgroundColor: 'var(--surface_container)',
                  border: '1px solid var(--border-ghost)',
                }}
              >
                <div
                  className="landing-stat__value landing-stat-value mb-1"
                  style={{ color: 'var(--accent-primary)' }}
                >
                  {t(`landing.stats.${statKey}.value`)}
                </div>
                <div
                  className="landing-stat__label"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {t(`landing.stats.${statKey}.label`)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsGrid;
